import React from "react"
import { useEffect, useState } from "react"

import Grid from "@material-ui/core/Grid"
import Paper from "@material-ui/core/Paper"

import { Form, Field, FormElement } from "@progress/kendo-react-form"
import { Input } from "@progress/kendo-react-inputs"
import { Button } from "@progress/kendo-react-buttons"
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs"
import { submitRegistration } from "../../Shared/Services/ApiService"

import logo from "../../Assets/Images/HolbaPrimarylogo_RGB.png"

export default function HolbaRegistration(props) {
  const { setAppBarTitle, backgroundProcessor, notificationCreate } = props
  const [formState, setFormState] = useState({})
  const [modal, setModal] = useState(false)
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [disabledEmail, setDisabledEmail] = useState(null)
  const [submission, setSubmission] = useState({
    type: "HOLBA",
    name: null,
    jobRole: null,
    businessEmail: null,
    businessName: null,
    address: null,
    postcode: null,
    contactNumber: null,
    dateTime: null,
    username: null,
  })

  useEffect(() => {
    setAppBarTitle("HOLBA Registration")
  }, [])

  const inputHandler = (e) => {
    let newValue = e.value
    let key = e.nativeEvent.srcElement.id

    if (key === "businessEmail" && disabledEmail !== newValue) {
      setDisabledSubmit(false)
    }

    if (key === "name") {
      let newUsername = null
      submission[key] = newValue

      newUsername = newValue.replace(/ /g, ".").toLowerCase()

      submission.username = newUsername
    }

    submission[key] = newValue

    setSubmission(submission)
  }

  const submitHandler = async (e) => {
    setModal(true)
  }

  const confirmHandler = async (e) => {
    backgroundProcessor?.add()

    submission.dateTime = new Date()

    try {
      const submit = await submitRegistration(submission)

      const response = submit.data.response.result
      console.log(response)

      if (response === "Registration Accepted") {
        setFormState(null)
        notificationCreate({
          severity: "success",
          message: "Request Submitted Succesfully",
        })
      } else if (response === "Registration Rejected - User Already Exists") {
        notificationCreate({
          severity: "error",
          message:
            "Request Submission Error - User Already Exists. Please amend and resubmit",
        })
        setDisabledSubmit(true)
        setDisabledEmail(submission.businessEmail)
      }
    } catch (error) {
      console.log("ERROR - " + error)
      notificationCreate({
        severity: "error",
        message: "Request Submission Error - Please Try Again",
      })
    }
    setModal(false)

    backgroundProcessor?.remove()
  }
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      style={{ paddingBottom: "1rem", backgroundColor: "lightgrey" }}
    >
      <Grid
        container
        item
        direction="column"
        alignItems="center"
        style={{ paddingBottom: "1rem", paddingTop: "2rem" }}
      >
        <Grid item>
          <h1>BIDS App - HOLBA User Registration</h1>
        </Grid>
      </Grid>

      <Grid container item direction="column" style={{ maxWidth: "95vw" }}>
        <Paper elevation={3} className="home-container">
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            style={{ paddingLeft: "1rem" }}
            spacing={3}
          >
            <Grid container item xs={4} direction="column">
              <Form
                initialValues={formState}
                onSubmit={submitHandler}
                key={formState}
                render={(formRenderProps) => (
                  <FormElement>
                    <Grid container direction="column">
                      <Grid item style={{ paddingBottom: "0.6rem" }}>
                        <Field
                          id="name"
                          name="name"
                          label="Name"
                          component={Input}
                          validator={(value) => {
                            return value ? "" : "Name is invalid."
                          }}
                          onChange={(e) => {
                            inputHandler(e)
                          }}
                        />
                      </Grid>

                      <Grid item style={{ paddingBottom: "0.6rem" }}>
                        <Field
                          id="jobRole"
                          name="jobRole"
                          label="Job Role"
                          component={Input}
                          validator={(value) => {
                            return value ? "" : "Job Role is invalid."
                          }}
                          onChange={(e) => {
                            inputHandler(e)
                          }}
                        />
                      </Grid>
                      <Grid item style={{ paddingBottom: "0.6rem" }}>
                        <Field
                          id="businessName"
                          name="businessName"
                          label="Business Name"
                          component={Input}
                          validator={(value) => {
                            return value ? "" : "Business name is invalid."
                          }}
                          onChange={(e) => {
                            inputHandler(e)
                          }}
                        />
                      </Grid>
                      <Grid item style={{ paddingBottom: "0.6rem" }}>
                        <Field
                          id="businessEmail"
                          name="businessEmail"
                          label="Business Email"
                          component={Input}
                          validator={(value) => {
                            return new RegExp(/\S+@\S+\.\S+/).test(value)
                              ? ""
                              : "Business Email is invalid."
                          }}
                          onChange={(e) => {
                            inputHandler(e)
                          }}
                        />
                      </Grid>
                      <Grid item style={{ paddingBottom: "0.6rem" }}>
                        <Field
                          id="address"
                          name="address"
                          label="1st Line of Address"
                          component={Input}
                          validator={(value) => {
                            return value ? "" : "1st Line of Address is invalid."
                          }}
                          onChange={(e) => {
                            inputHandler(e)
                          }}
                        />
                      </Grid>
                      <Grid item style={{ paddingBottom: "0.6rem" }}>
                        <Field
                          id="postcode"
                          name="postcode"
                          label="Postcode"
                          component={Input}
                          validator={(value) => {
                            return value ? "" : "Postcode is invalid."
                          }}
                          onChange={(e) => {
                            inputHandler(e)
                          }}
                        />
                      </Grid>
                      <Grid item style={{ paddingBottom: "0.6rem" }}>
                        <Field
                          id="contactNumber"
                          name="contactNumber"
                          label="Contact Number"
                          component={Input}
                          validator={(value) => {
                            return new RegExp(/^(?:0|\+?44)(?:\d\s?){9,10}$/).test(
                              value
                            )
                              ? ""
                              : "Contact number is invalid."
                          }}
                          onChange={(e) => {
                            inputHandler(e)
                          }}
                        />
                        <Grid item>
                          <p style={{ fontSize: "12px" }}>
                            Must start with 0 and not contain any spaces or non digit
                            characters
                          </p>
                        </Grid>
                      </Grid>
                    </Grid>
                    <span
                      style={{ marginTop: "20px" }}
                      className={"k-form-separator"}
                    />
                    <div
                      style={{
                        justifyContent: "space-between",
                        alignContent: "center",
                      }}
                      className={"k-form-buttons k-buttons-end"}
                    >
                      <div>
                        <Button
                          type={"submit"}
                          disabled={
                            !formRenderProps.allowSubmit ||
                            disabledSubmit ||
                            disabledEmail === submission.businessEmail
                          }
                          style={{ color: "white", background: "#7ABCCE" }}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </FormElement>
                )}
              />
            </Grid>
            <Grid container item xs={6} direction="column">
              <p
                style={{
                  paddingBottom: "1rem",
                  paddingTop: "1rem",
                  fontWeight: "bold",
                }}
              >
                Please fill out all fields, double checking that all the information
                entered is accurate and then click submit.
              </p>
              <p style={{ fontWeight: "bold" }}>
                Your request will then be processed by one of our team before your
                login details are sent to the email address entered
              </p>
              <img src={logo} style={{ objectFit: "contain" }} alt="logo" />
            </Grid>
          </Grid>
          {modal && (
            <Dialog
              title={"Registration Request"}
              onClose={(e) => setModal(false)}
              height="68vh"
              width="30vw"
              style={{ border: "1px solid #E95F47" }}
            >
              <Grid
                container
                direction="column"
                alignItems="flex-start"
                style={{ marginTop: "0.3rem" }}
                spacing={2}
              >
                <Grid item>
                  <p>
                    Please check all values before confirming your submission, or
                    click cancel to make any changes
                  </p>
                  <p>You will be contacted by email once approved</p>
                </Grid>
                <Grid item>
                  <strong>Name:</strong> {submission.name}
                </Grid>
                <Grid item>
                  <strong>Job Role:</strong> {submission.jobRole}
                </Grid>
                <Grid item>
                  <strong>Business Name:</strong> {submission.businessName}
                </Grid>
                <Grid item>
                  <strong>Business Email:</strong> {submission.businessEmail}
                </Grid>

                <Grid item>
                  <strong>1st Line of Address:</strong> {submission.address}
                </Grid>

                <Grid item>
                  <strong>Postcode:</strong> {submission.postcode}
                </Grid>

                <Grid item>
                  <strong>Contact Number:</strong> {submission.contactNumber}
                </Grid>
              </Grid>
              <DialogActionsBar>
                <>
                  <Button
                    style={{ backgroundColor: "#E95F47", color: "white" }}
                    onClick={(e) => confirmHandler(e)}
                  >
                    Confirm
                  </Button>
                  <Button
                    style={{ backgroundColor: "#E95F47", color: "white" }}
                    onClick={(e) => setModal(false)}
                  >
                    Cancel
                  </Button>
                </>
              </DialogActionsBar>
            </Dialog>
          )}
        </Paper>
      </Grid>
    </Grid>
  )
}
